import { createContext } from 'react';

type Context = {
  timezone: string;
};

export const TimezoneContext = createContext<Context>({
  timezone: 'Asia/Tokyo',
});
